<template>
    <div class="list-container">
        <BRow>
            <BCol sm="12" md="12" lg="12" xl="4">
                <p class="scanner-description-text" v-if="showDescription">
                    Click on an item picture in Pack & Go. A pop-up will appear to simulate a real product.<br><br>
                    Now scan the barcode of your products to mark the item as 'packed' in Pack & Go.<br><br>
                    Once all items are marked as packed, a label will print automatically.  
                </p>
                <ScannerPickingList @open-modal="openModal" class="d-none d-xl-block"></ScannerPickingList>
                <div class="d-block d-xl-none mt-2 mb-3">
                    <BButton @click="toggleCollapse" class="scanner-go-back-btn w-50 mb-2" style="background-color: #112857;">{{ !isCollapsed ? 'View Picking List' : 'Hide Picking List'}}</BButton>
                    <BCollapse v-model="isCollapsed" class="mb-2">
                        <ScannerPickingList @open-modal="openModal"></ScannerPickingList>
                    </BCollapse>
                </div>
                <div v-if="showDescription" class="w-50 mt-5 d-none d-xl-block">
                    <div class="scanner-btn-sub-question">Explore the other method?</div>
                    <div style="padding-left: 20px; padding-right: 20px">
                        <router-link to="/pack-go">
                            <BButton class="scanner-go-back-btn">
                                Go Back
                            </BButton>
                        </router-link>
                    </div>
                </div>
            </BCol>
            <BCol sm="12" md="12" lg="12" xl="8" class="data-table-container">
                <div>
                    <div class="d-flex justify-content-between flex-column flex-lg-row justify-content-sm-center justify-content-lg-between">
                        <div class="d-flex align-items-center mx-auto mx-lg-0">
                            <div class="text-title">
                                Pack & Go
                            </div>
                            <div class="toggle-switch" :class="{ 'checked': singleScan }" @click="toggle()">
                                <div class="toggle-handle"></div>
                            </div>
                            <div class="toggle-label">
                                Single scan
                            </div>
                            <div class="toggle-label-alt">
                                (what is single scan?)
                            </div>
                        </div>
                        <div class="mx-auto mx-lg-0 mt-3 mt-lg-0">
                            <div class="d-flex align-items-center">
                                <img src="~@/assets/pack_go/printer-icon-2.svg" style="height: 1rem; width: 1rem;">
                                <div class="print-options-label">
                                    Print Options
                                </div>
                                <div class="d-flex align-items-center" style="width: 310px;">
                                    <BInputGroup>
                                        <template #append>
                                            <BInputGroupText class="search-btn"><font-awesome-icon icon="search" style="color: #ffffff"/></BInputGroupText>
                                        </template>
                                        <BFormInput class="search-input" placeholder="Search by order or barcode"></BFormInput>
                                    </BInputGroup>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ItemList 
                        v-if="selectedOrder === 0 || selectedOrder === 1 || selectedOrder === 2"
                        :item_index="selectedOrder"
                        @open-modal="openModalLabelBtn()"
                        class="mb-3 mt-3">
                    </ItemList>
                    <ItemList v-else :is_empty="true" class="mb-3 mt-3"></ItemList>
                    <OrderTable
                        @open-modal="openModalLabelBtn()"
                        v-if="selectedOrder === 0 || selectedOrder === 1 || selectedOrder === 2"
                        :item_index="selectedOrder"
                        :selected_order="selectedOrder"
                        :table_type="'scan'">
                    </OrderTable>
                    <div v-else class="empty-state">
                        <div class="image-div">
                            <img src="~@/assets/pack_go/empty-state.png">
                        </div>
                        <p class="empty-state-title">No order selected</p>
                        <p class="empty-state-message">Select an order by using a scanner or by entering an order number or barcode in the search bar.</p>
                    </div>
                </div>
            </BCol>
        </BRow>
        <div v-if="showDescription" class="w-50 mt-5 d-block d-xl-none">
            <div class="scanner-btn-sub-question">Explore the other method?</div>
            <div style="padding-left: 20px; padding-right: 20px">
                <router-link to="/pack-go">
                    <BButton class="scanner-go-back-btn">
                        Go Back
                    </BButton>
                </router-link>
            </div>
        </div>
        <div v-if="!showDescription" class="list-container">
            <div class="scanner-footer-container">
                <div class="d-flex justify-content-between flex-column flex-lg-row">
                    <BCol v-if="singleScan" sm="12" md="12" lg="6">
                        <div class="scanner-lorem-text">
                            Single scan lets you locate an order and print labels in one scan. Just scan an order on the picking list to print the correct shipping label for that order. 
                        </div>
                    </BCol>
                    <BCol v-else sm="12" md="12" lg="6">
                        <div class="scanner-lorem-text">
                            Welcome to the Scanner mode demo!<br><br>
                            Start by scanning the order on your picking list to bring up the order in Pack & Go.<br><br>
                            Or to accelerate your order processing, toggle on Single scan.
                        </div>
                    </BCol>
                    <BCol sm="12" md="12" lg="3" style="padding-right: 0 !important;" class="mt-2 mt-lg-0">
                        <div class="scanner-btn-sub-question">Explore the other method?</div>
                        <div>
                            <router-link to="/pack-go">
                                <BButton class="scanner-go-back-btn">
                                    Go Back
                                </BButton>
                            </router-link>
                        </div>
                    </BCol>
                </div>
            </div>
        </div>
        <BModal v-model="showLoading" no-close-on-backdrop :hide-footer="true" :hide-header="true" :size="'md'" centered title="BootstrapVue">
            <div v-if="!showPrint" class="modal-style">
                <img class="transition-style" v-bind:style="{transform: `rotate(${deg}deg)`}" src="~@/assets/pack_go/gear-icon.svg"/>
                <p class="text-center">Your label is beeing generated.<br>Please wait...</p>
            </div>
            <div v-else class="modal-style-two">
                <img src="~@/assets/pack_go/printer-icon-modal.svg"/>
                <p>Print Label.</p>
            </div>
        </BModal>
    </div>
</template>

<script>
import { BButton, BCol, BCollapse, BContainer, BFormInput, BInputGroup, BInputGroupText, BModal, BRow } from 'bootstrap-vue';
import ItemList from './ItemList.vue';
import OrderTable from './OrderTable.vue';
import ScannerPickingList from './ScannerPickingList.vue';

export default {
    components: {
    BRow,
    BCol,
    ScannerPickingList,
    BButton,
    BContainer,
    BInputGroup,
    BInputGroupText,
    BFormInput,
    OrderTable,
    ItemList,
    BModal,
    BCollapse
},
    data() {
        return {
            showDescription: false,
            showLoading: false,
            showPrint: false,
            deg: 360,
            interval: null,
            counter: 0,
            singleScan: false,
            selectedOrder: null,
            isCollapsed: false,
        }
    },
    methods: {
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
        toggle() {
            this.singleScan = !this.singleScan;
            if(this.singleScan) {
                this.selectedOrder = null;
                this.showDescription = false;
            }
        },
        rotation() {
            this.showPrint = false
            this.counter++;
            this.deg -= 30;

            if (this.counter >= 3) {
                clearInterval(this.interval);
                this.deg -= 90;
                this.showPrint = true;
                setTimeout(() => {
                    this.showLoading = false
                    this.deg = 360
                    this.$router.push({ path: '/pack-go/print' })
                }, 2000);
            }
        },
        openModalLabelBtn(order) {
            this.showLoading =  true
            this.interval = setInterval(this.rotation, 1000);
        },
        openModal(order) {
            if(this.singleScan) {
                this.showLoading =  true
                this.interval = setInterval(this.rotation, 1000);
            } else {
                this.selectedOrder = order
                this.showDescription = true
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.interval);
    }
}
</script>

<style>
.list-container {
    max-width: 100% !important;
    padding-top: 40px;
    padding-bottom: 20px;
    overflow: hidden;
}

.items-list {
    width: 100%;
}

.scanner-description-text {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    display: flex;
    align-items: center;
    color: #212121;
    margin-bottom: 43px;
    background-color: #F4FAFF;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid #E8E8E8;
    border-radius: 6px;
}

@media (max-width: 768px) {
    .scanner-description-text {
        margin-bottom: 20px;
    }
}

.scanner-footer {
    margin-top: 60px;
    margin-bottom: 20px;
}

.scanner-footer-container {
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
}

.scanner-lorem-text {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    color: #212121;
    background-color: #F4FAFF;
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid #E8E8E8;
    border-radius: 6px;
    padding-left: 10px;
}

.scanner-btn-sub-question {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #000000;
    margin-bottom: 21px;
}

.scanner-go-back-btn {
    background-color: #1D97FF;
    height: 43px;
    width: 100%;
    border: 1px solid #1D97FF;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin-left: auto;
}

.data-table-container {
    background-color: #F4FAFF;
    padding: 45px 33px;
    background: #F4FAFF;
    border: 1px solid #E8E8E8;
    border-radius: 8px;
}

.text-title {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    display: flex;
    align-items: center;
    color: #212121;
}

.toggle-switch {
  width: 36px;
  height: 12px;
  border-radius: 15px;
  position: relative;
  cursor: pointer;
  border: 1px solid #1D97FF;
  margin-left: 13px;
}

.toggle-handle {
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  left: -3px;
  border: 1px solid #112857;
  transition: transform 0.3s;
}

.toggle-switch.checked {
  background-color: #1D97FF;
}

.toggle-switch.checked .toggle-handle {
  transform: translateX(20px);
  background-color: #112857;
}

.toggle-label {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    display: flex;
    margin-left: 8px;
    color: #212121;
}

.toggle-label-alt {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    display: flex;
    color: #0070D0;
}

.print-options-label {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    text-align: center;
    color: #112857;
    margin-left: 10px;
}

.search-btn {
    height: 2.5rem;
    background-color: #112857;
    border: 1px solid #112857;
    border-radius: 0px 6px 6px 0px;
}

.search-input {
    margin-left: 10px;
    height: 2.5rem;
    border: 1px solid #112857;
}

.search-input::placeholder {
    font-size: 0.9rem;
}

.modal-style {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 26px;
    transition: opacity 0.5s ease;
}

.modal-style p {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #212121;
    margin-top: 24px;
}

.modal-style-two {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 26px;
    transition: opacity 0.5s ease;
}

.modal-style-two p {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #212121;
    margin-top: 24px;
}

.transition-style {
    transition: transform 0.5s ease-in-out;
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

.empty-state {
    background-color: #ffffff;
    border: 1px solid #C3C5C7;
    border-radius: 6px;
    padding-top: 49px;
    padding-bottom: 49px;
}

.empty-state .image-div {
    display: flex;
    direction: column;
}

.empty-state .image-div img {
    margin-left: auto;
    margin-right: auto;
}

.empty-state-title {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    margin-top: 14px;
    text-align: center;
    color: #112857;
}

.empty-state-message {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 0.8rem;
    line-height: 18px;
    align-items: center;
    text-align: center;
    color: #212121;
    width: 301px;
    margin-left: auto;
    margin-right: auto;
}
</style>